<template>
  <div id="home">
    <topbar/>
    <hero/>
    <sect v-if="isDesktop" class="features">
      <wrap class="rel">
        <feature
          v-for="({ title, text, icon }, index) in features"
          :title="title"
          :texts="[text]"
          :icon="icon"
          :index="index"
          :key="title"/>
      </wrap>
      <div class="overlay"></div>
    </sect>
    <sect class="showcase">
      <home-sect
        v-for="({ text, image, title }, index) in showcase"
        :class="{ first: index === 0, last: index === (showcase.length - 1) }"
        :image="image"
        :index="index + 1"
        :key="index"
        :text="text"
        :title="title"/>
    </sect>
    <sect class="signup">
      <btn to="Signup" class="ib lg round info">
        Signup
      </btn>
    </sect>
    <sect class="footer">
      <wrap>
        Copyright © {{ new Date() | year }} Jobcarda
      </wrap>
    </sect>
  </div>
</template>

<script>
import Feature from './components/Feature'
import Hero from './components/landing/Hero'
import HomeSect from './components/HomeSect'
import Topbar from './components/Topbar'
import { getters } from './utils'

export default {
  components: { Feature, Hero, HomeSect, Topbar },
  data() {
    return {
      showcase: [
        {
          title: 'Whole day in a glance',
          text: 'The more work you take up, the more difficult it gets to find time for it. To solve this, Jobcarda comes with an integrated calendar for scheduling tasks in advance and reviewing past work.',
          image: 'glance',
        },
        {
          title: 'Your work. Organized.',
          text: 'Organizing with pen and paper is more trouble than it should be. We wanted to make this more conveniant and less repetative. That\'s why we developed jobcards, clients, vehicles and invoices that keep data in-sync.',
          image: 'organized',
        },
        {
          title: 'Keep your team in the loop',
          text: 'It\'s critical to make sure that everyone is on the same page. That\'s why we developed a one page - overview of the current state of your auto service shop.',
          image: 'team',
        },
      ],
      features: [
        {
          icon: 'o-puzzle',
          title: 'Don\'t lose any details',
          text: 'Keep records on what was done, how much it cost in.',
          // theme: 'fancy',
        },
        {
          icon: 'o-search',
          title: 'Automated invoices',
          text: 'Save time that is usually spent writing on invoices. Invoices are automatically generated and can be downloaded in multiple formats.',
          // theme: 'fancy',
        },
        {
          icon: 'o-phone',
          title: 'Accessable from any device',
          text: 'Keep tabs on your work whenever you\'re using a desktop PC, a laptop, a tablet or a smartphone. All features are available on all platforms.',
          // theme: 'danger',
        },
        {
          icon: 'o-lock',
          title: 'Securely stored',
          text: 'All information is encrypted and stored in the cloud. All communication with the server is also heavily encrypted.',
          // theme: 'success',
        },
      ],
    }
  },
  computed: getters('isDesktop', 'routeAfterLogin'),
  watch: {
    isAuth() {
      if (this.isAuth) {
        this.$router.push(this.routeAfterLogin)
      }
    },
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.sect {
  &.showcase {
    background: #fff;
    padding-bottom: 0;
    > h2 {
      color: $c-text;
      font-size: $h1;
      margin: 3.5rem 0 2.5rem;
    }
    // .feature {
    //   .image {
    //     background: $c-grey;
    //     border: 10px solid #fff;
    //     border-radius: $r-round * 2;
    //     box-shadow: $s-lg inset, $s-lg;
    //     height: 220px;
    //     margin-bottom: 2rem;
    //     overflow: hidden;
    //     width: 220px;
    //   }
    // }
  }
  // &.features {
  //   background: #fff;
  //   // background: #d4d4d4;
  //   // padding: 4rem 0 2.5rem;
  //   .feature {
  //     background: #fff;
  //     box-shadow: $s-lg;
  //     padding: 2rem;
  //     text-align: center;
  //     .image {
  //       background: $c-navy;
  //       border-radius: $r-round;
  //       display: inline-block;
  //       height: 80px;
  //       position: relative;
  //       text-align: center;
  //       width: 80px;
  //       .ic {
  //         color: #fff;
  //         display: block;
  //         font-size: $h1 * 0.8;
  //         left: 0;
  //         line-height: 90px;
  //         position: absolute;
  //         text-align: center;
  //         top: 0;
  //         width: 100%;
  //       }
  //       &.fancy {
  //         background: $c-fancy;
  //       }
  //       &.success {
  //         background: $c-success;
  //       }
  //       &.danger {
  //         background: $c-danger;
  //       }
  //       // img {
  //       //   opacity: 0.5;
  //       // }
  //     }
  //     h3 {
  //       font-size: ($h3 + $h4) / 2;
  //       text-align: center;
  //     }
  //   }
  // }
  &.signup {
    background: #fff;
    padding: 3rem 0;
    text-align: center;
    .btn {
      background: linear-gradient(90deg, lighten($c-info, 8%), lighten($c-info, 3%));
      box-shadow: 0 0 0 rgba($c-info, 0.01);
      font-size: $h4;
      &:hover {
        background: linear-gradient(90deg, lighten($c-info, 5%), $c-info);
        box-shadow: 0 6px 24px rgba($c-info, 0.5);
      }
    }
  }
  &.footer {
    background: $c-info;
    border-top: 9px solid mix($c-navy, $c-info, 15%);
    color: #fff;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue